// Menu entries and vocabulary of the dashboard packs, kept free of any page import so they can be tested on their own.
// Top-level entries are sorted by `order`; `group: true` is a drawer whose children name it in `parent`; a `module` switches
// an entry off for a category that does not have that module; `separator: true` is a divider inside a drawer.

export const coreMessages = {
    ar: {
      "nav.home": "الرئيسية",
      "nav.billing": "اشتراكي",
      "nav.meetings": "الميتنج",
      "nav.courses": "الدورات التعليمية",
      "nav.gallery": "المعرض",
      "nav.galleryProjects": "معرض الأعمال",
      "nav.resources": "الموارد",
      "nav.settings": "الإعدادات",
      "nav.domain": "الدومين الخاص",
      "nav.deviceLimit": "حد الأجهزة",
      "nav.shareMeta": "مشاركة الرابط",
      "nav.contactInfo": "معلومات التواصل",
      "nav.look": "شكل الموقع (الثيم)",
      "nav.branding": "هوية الموقع",
      "nav.meetingReminder": "تذكير الميتنج",
      "nav.more": "المزيد",
      "nav.inbox": "البريد الوارد",
      "nav.news": "الأخبار",
      "nav.links": "الروابط",
      "nav.notifications": "الاشعارات",
      "nav.schedule": "المواعيد",
      "nav.homeContent": "محتوى الصفحة الرئيسية",
      "common.alert": "تنبيه",
      "common.done": "تم بنجاح",
      "common.failed": "حصلت مشكلة، حاول تاني",
      "common.save": "حفظ",
      "common.delete": "حذف",
      "content": "محتوى الصفحة الرئيسية",
      "content.noteTitle": "النصوص اللي بتظهر في موقعك",
      "content.note": "ثيم موقعك بيرتّب أقسام في الصفحة الرئيسية (أرقام، خطوات، آراء الطلاب، أسئلة، لوحة الشرف...). هنا بتكتب النصوص اللي جوّاها. أي قسم تسيبه فاضي بيختفي أو بيظهر بكلام جاهز. الصور والعنوان الرئيسي من «هوية الموقع»، والكورسات والحصص والدروس المجانية بتيجي من صفحاتها.",
      "content.cta": "الزرار والشريط الختامي",
      "content.ctaLabel": "كلام الزرار (الافتراضي: ابدأ مجانًا)",
      "content.ctaTitle": "عنوان الشريط الختامي",
      "content.ctaText": "نص الشريط الختامي",
      "content.stats": "أرقام تثق فيها",
      "content.statsHint": "لحد 4 أرقام، مثلًا «+12,000» و«طالب ذاكروا معانا». بتظهر في أول الصفحة وتحت التعريف بيك.",
      "content.statValue": "الرقم",
      "content.statLabel": "الوصف",
      "content.features": "المميزات",
      "content.icon": "أيقونة (إيموجي)",
      "content.title": "العنوان",
      "content.text": "النص",
      "content.testimonials": "آراء الطلاب",
      "content.name": "الاسم",
      "content.role": "الوصف (اختياري)",
      "content.quote": "الرأي",
      "content.faq": "أسئلة شائعة",
      "content.question": "السؤال",
      "content.answer": "الإجابة",
      "content.apps": "تطبيق الموبايل",
      "content.ios": "رابط App Store",
      "content.android": "رابط Google Play",
      "content.add": "إضافة",
      "content.saved": "اتحفظ المحتوى",
      "content.subject": "قسم التخصص",
      "content.subjectHint": "الثيمات الجديدة فيها قسم خاص بمادتك (مسألة الأسبوع، الجدول الدوري، مشاريع البرمجة...). لو سيبته فاضي هيظهر بكلام جاهز مناسب للثيم.",
      "content.subjectEyebrow": "كلمة صغيرة فوق العنوان",
      "content.subjectTitle": "العنوان",
      "content.subjectText": "الوصف",
      "content.subjectItemsHint": "عناصر القسم: في «مسألة الأسبوع» اكتب المسألة في العنوان والاختيارات في التفاصيل مفصولة بـ / وعلّم الصح بـ *، مثلًا: 0 / 1 / 2* / π. وفي باقي الثيمات كل عنصر بعنوان وتفاصيل.",
      "content.subjectSub": "التفاصيل",
      "content.steps": "إزاي تبدأ",
      "content.stepsHint": "لحد 4 خطوات. لو سيبتها فاضية هتظهر 3 خطوات جاهزة: سجّل، اختار كورسك، اتعلّم وتابع تقدّمك.",
      "content.honor": "لوحة الشرف",
      "content.honorHint": "لحد 8 طلاب ودرجاتهم، والأول بيتميّز بكأس. لو سيبتها فاضية القسم مش هيظهر.",
      "content.score": "الدرجة",
    },
  };

export const coreMenu = [
    { key: "home", labelKey: "nav.home", icon: "pi pi-fw pi-home", url: "/welcome", order: 10 },
    { key: "billing", labelKey: "nav.billing", icon: "pi pi-fw pi-wallet", url: "/billing", order: 20 },
    { key: "meetings", labelKey: "nav.meetings", icon: "pi pi-fw pi-desktop", url: "/meetings", module: "MEETINGS", order: 30 },
    { key: "courses", labelKey: "nav.courses", icon: "pi pi-fw pi-book", url: "/courses", module: "COURSES", order: 60 },
    { key: "gallery", labelKey: "nav.gallery", icon: "pi pi-fw pi-images", group: true, order: 70 },
    { parent: "gallery", labelKey: "nav.galleryProjects", icon: "pi pi-fw pi-images", url: "/gallery-projects", module: "GALLERY", order: 1 },
    { parent: "gallery", labelKey: "nav.resources", icon: "pi pi-fw pi-file", url: "/resources", module: "RESOURCES", order: 2 },
    { key: "settings", labelKey: "nav.settings", icon: "pi pi-fw pi-cog", group: true, order: 110 },
    { parent: "settings", labelKey: "nav.domain", icon: "pi pi-fw pi-globe", url: "/settings/domain", order: 30 },
    { parent: "settings", labelKey: "nav.deviceLimit", icon: "pi pi-fw pi-desktop", url: "/settings/device-limit", order: 40 },
    { parent: "settings", labelKey: "nav.shareMeta", icon: "pi pi-fw pi-share-alt", url: "/settings/share-meta", order: 50 },
    { parent: "settings", labelKey: "nav.contactInfo", icon: "pi pi-fw pi-phone", url: "/settings/contact-info", order: 60 },
    { parent: "settings", labelKey: "nav.look", icon: "pi pi-fw pi-eye", url: "/settings/look", order: 70 },
    // what the theme's home sections say; a coach has the same page in their own menu (packs/gym, /site-content)
    { parent: "settings", labelKey: "nav.homeContent", icon: "pi pi-fw pi-pencil", url: "/settings/home-content", module: "LESSONS", order: 75 },
    { parent: "settings", labelKey: "nav.branding", icon: "pi pi-fw pi-palette", url: "/settings/branding", order: 80 },
    { parent: "settings", labelKey: "nav.meetingReminder", icon: "pi pi-fw pi-bell", url: "/settings/meeting-reminder", module: "MEETINGS", order: 90 },
    { key: "more", labelKey: "nav.more", icon: "pi pi-fw pi-list", group: true, order: 120 },
    { parent: "more", labelKey: "nav.inbox", icon: "pi pi-fw pi-list", url: "/allInbox", module: "INBOX", order: 10 },
    { parent: "more", labelKey: "nav.news", icon: "pi pi-fw pi-calendar", url: "/news/add", module: "NEWS", order: 20 },
    { parent: "more", labelKey: "nav.links", icon: "pi pi-fw pi-calendar", url: "/links/add", order: 40 },
    { parent: "more", labelKey: "nav.notifications", icon: "pi pi-fw pi-calendar", url: "/notifications/add", order: 50 },
    { parent: "more", labelKey: "nav.schedule", icon: "pi pi-fw pi-calendar", url: "/schedule", order: 60 },
  ];

export const schoolMessages = {
    ar: {
      "nav.lessons": "الحصص",
      "nav.students": "الطلاب",
      "nav.activateStudents": "تفعيل الطلاب",
      "nav.myStudents": "طلابي",
      "nav.securityFlags": "تنبيهات الأمان",
      "nav.periods": "الفترات",
      "nav.allPeriods": "كل الفترات",
      "nav.allSubscriptions": "كل الإشتراكات",
      "nav.exams": "الإمتحانات",
      "nav.faq": "الاسئله الشائعه",
      "nav.reports": "التقارير",
      "nav.schoolStages": "المراحل الدراسية",
      "nav.materials": "المواد",
      "nav.reparation": "التعويضات",
    },
  };

export const schoolMenu = [
    { key: "lessons", labelKey: "nav.lessons", icon: "pi pi-fw pi-video", url: "/lessons", module: "LESSONS", order: 40 },
    { key: "students", labelKey: "nav.students", icon: "pi pi-fw pi-user", group: true, module: "SCHOOL_STRUCTURE", order: 50 },
    { parent: "students", labelKey: "nav.activateStudents", icon: "pi pi-fw pi-user", url: "/students", order: 1 },
    { parent: "students", labelKey: "nav.myStudents", icon: "pi pi-fw pi-user", url: "/myStudents", order: 2 },
    { parent: "students", labelKey: "nav.securityFlags", icon: "pi pi-fw pi-shield", url: "/students/security-flags", order: 3 },
    { key: "periods", labelKey: "nav.periods", icon: "pi pi-fw pi-calendar", group: true, module: "SCHOOL_STRUCTURE", order: 55 },
    { parent: "periods", labelKey: "nav.allPeriods", icon: "pi pi-fw pi-calendar", url: "/subscriptions/addPeriod", order: 1 },
    { parent: "periods", separator: true, order: 2 },
    { parent: "periods", labelKey: "nav.allSubscriptions", icon: "pi pi-fw pi-calendar", url: "/subscriptions", order: 3 },
    { key: "exams", labelKey: "nav.exams", icon: "pi pi-fw pi-list", url: "/exams", module: "EXAMS", order: 80 },
    { key: "faq", labelKey: "nav.faq", icon: "pi pi-fw pi-question-circle", url: "/commonQuestions", module: "EXAMS", order: 90 },
    { key: "reports", labelKey: "nav.reports", icon: "pi pi-fw pi-chart-bar", url: "/examsReports", module: "EXAMS", order: 100 },
    { parent: "settings", labelKey: "nav.schoolStages", icon: "pi pi-fw pi-sitemap", url: "/settings/school-stages", module: "SCHOOL_STRUCTURE", order: 10 },
    { parent: "settings", labelKey: "nav.materials", icon: "pi pi-fw pi-book", url: "/settings/materials", module: "SCHOOL_STRUCTURE", order: 20 },
    { parent: "more", labelKey: "nav.reparation", icon: "pi pi-fw pi-calendar", url: "/reparation/add", module: "LESSONS", order: 30 },
  ];

const allowed = (entry, modules) => !entry.module || modules.indexOf(entry.module) >= 0;

/** The rail from a list of entries: those whose module the account has, top-level by order, each drawer with its children by
 *  order; a drawer left with no child is dropped. {@code translate} turns a labelKey into text. */
export function buildMenuFrom(entries, modules, translate) {
  const visible = entries.filter((e) => allowed(e, modules));
  const byOrder = (a, b) => (a.order || 0) - (b.order || 0);
  const label = (e) => (e.labelKey ? translate(e.labelKey) : e.label);

  const children = {};
  visible
    .filter((e) => e.parent)
    .sort(byOrder)
    .forEach((e) => {
      (children[e.parent] = children[e.parent] || []).push(
        e.separator ? { separator: true } : { label: label(e), icon: e.icon, url: e.url }
      );
    });

  return visible
    .filter((e) => !e.parent)
    .sort(byOrder)
    .map((e) =>
      e.group
        ? { label: label(e), icon: e.icon, items: children[e.key] || [] }
        : { label: label(e), icon: e.icon, url: e.url }
    )
    .filter((item) => item.url || item.items.some((k) => !k.separator));
}

export function isAllowed(entry, modules) {
  return allowed(entry, modules);
}
